import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function TransformationSection() {
  const benefits = ['Comprender cómo funciona el sistema', 'Conocer tus derechos', 'Interpretar mejor tu situación', 'Tomar decisiones con más confianza', 'Reducir la incertidumbre', 'Tener información organizada en un solo lugar'];
  return <section className="py-16 md:py-24 px-4 bg-surface relative overflow-hidden" data-id="element-370">
      <div className="max-w-4xl mx-auto text-center" data-id="element-371">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12" data-id="element-372">
          <h2 className="text-3xl md:text-5xl font-black text-slate-dark mb-6" data-id="element-373">
            Imagina tener claridad sobre tu situación
          </h2>
          <p className="text-lg md:text-xl text-slate font-medium max-w-2xl mx-auto" data-id="element-374">
            El conocimiento es el primer paso para avanzar.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-4 max-w-3xl mx-auto text-left" data-id="element-375">
          {benefits.map((benefit, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-surface-gray p-4 rounded-xl flex items-center gap-3 border border-gray-100" data-id="element-376">
              <CheckCircle2 className="w-6 h-6 text-brand-green shrink-0" data-id="element-377" />
              <span className="font-medium text-slate-dark" data-id="element-378">{benefit}</span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}